import * as React from "react"
import type { IconProps } from "../types"

const Filter = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          stroke={color}
          strokeWidth={2}
          d="M20.25 3.75H3.75V8L9.75 14V21L14.25 20V14L20.25 8V3.75Z"
        />
      </svg>
    )
  }
)
Filter.displayName = "Filter"

export default Filter
